module.exports = __webpack_public_path__ + "ss.svg?617f56e81e0c15b446d266b08ab2fd6a";